import ErrorBoundary from "Components/ErrorBoundary";
import React, { ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { RootState } from "store";
import { DarkMode } from "store/darkMode/initialState";
import { SideNav } from "store/sideBar/initialState";
import Modals from "view/components/Modals";
import SideBar from "view/components/SideBar";
import "./layout.scss";
import useCustomBranding from "hooks/useCustomBranding";

interface LayoutProps {
  children?: ReactNode;
}

const Layout: React.FC<LayoutProps> = () => {
  const { isDarkMode } = useSelector<RootState, DarkMode>(
    (state) => state?.darkMode
  );
  const { isCollapsed } = useSelector<RootState, SideNav>(
    (state) => state?.sideBar
  );
  const { theme } = useCustomBranding();
  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [isDarkMode]);

  return (
    <div 
      className={`flex w-full min-h-[100vh] ${isDarkMode && "dark:bg-bgMain "}`}
    >
      <div className={`fixed z-50 flex h-full ${theme?.brandCode === "isn" ? `bg-bgLightGrey` : `bg-bgNeutralGrey`}`}>
        <SideBar />
      </div>
      <div
        className={`flex flex-col flex-1 items-center justify-start px-5 overflow-x-hidden overflow-y-auto ${theme?.brandCode === "isn" ? `bg-bgLightGrey` : `bg-bgNeutralGrey`} dark:bg-bgMain  
      transition-all
       ${isCollapsed ? "ml-[80px]" : "ml-[235px]"}
      `}
      >
        <ErrorBoundary>
          <Modals />
          <Outlet />
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default Layout;
